import { UHC } from '../types';

// FHIR Flag category rank for the UHC Premium Physician disclaimer, per UHC's
// $care-estimator Flag resource: category[0].coding[0].code === '5' where
// category[0].coding[0].display === "Premium Disclaimer". It renders in the
// "What is UnitedHealth Premium Care Physician?" modal, so it is excluded from
// the footer disclaimer list to avoid a double render.
export const PREMIUM_PHYSICIAN_DISCLAIMER_CATEGORY_RANK = '5';

// The Premium Physician disclaimer (matched on the stable category rank, not the
// localized display name) is rendered in its own modal.
export const getPremiumPhysicianDisclaimerHtml = (
  disclaimers: UHC.Disclaimer[] | undefined,
): string | undefined =>
  disclaimers?.find(
    (disclaimer) => disclaimer.categoryRank === PREMIUM_PHYSICIAN_DISCLAIMER_CATEGORY_RANK,
  )?.message;

// Everything shown in the footer disclaimer list — i.e. all disclaimers except
// the Premium Physician one, which lives in the modal (avoids a double render).
export const getFooterDisclaimers = (
  disclaimers: UHC.Disclaimer[] | undefined,
): UHC.Disclaimer[] | undefined =>
  disclaimers?.filter(
    (disclaimer) => disclaimer.categoryRank !== PREMIUM_PHYSICIAN_DISCLAIMER_CATEGORY_RANK,
  );

const sortDisclaimersByCategory = (
  disclaimers: UHC.Disclaimer[] | undefined,
): Record<UHC.Disclaimer['categoryName'], UHC.Disclaimer['message'][]> => {
  // Copy before sorting so the caller's array is never mutated in place.
  const sorted = [...(disclaimers ?? [])].sort((a, b) => {
    if (a.categoryRank > b.categoryRank) return 1;
    if (a.categoryRank === b.categoryRank) {
      if (a.internalCategoryRank > b.internalCategoryRank) return 1;
      if (a.internalCategoryRank < b.internalCategoryRank) return -1;
      return 0;
    }
    return -1;
  });
  const sortedByCategory: Record<string, string[]> = {};
  sorted.forEach(({ categoryName, message }) => {
    if (!sortedByCategory[categoryName]) {
      sortedByCategory[categoryName] = [];
    }
    sortedByCategory[categoryName].push(message);
  });
  return sortedByCategory;
};

export default sortDisclaimersByCategory;
